<div class="main-tab">
    <main-tab-personal [dictData]="dictData" (onInit)="addForm($event)"></main-tab-personal>
    <main-tab-email [dictData]="dictData" (onFormAdd)="addForm($event)"></main-tab-email>
    <main-tab-phone [dictData]="dictData" (onFormAdd)="addForm($event)"></main-tab-phone>
    <main-tab-address [dictData]="dictData" (onFormAdd)="addForm($event)"></main-tab-address>
</div>